// extracted by mini-css-extract-plugin
module.exports = {"subtitleLink":"_44e6f9f9","subtitle":"_357d0919"};